/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

if ($('.image-popup').parent().length) {
  if (!Cookies.get('seen_popup_june')) {
    $('.image-popup').css('display', 'block');
  }
}

$('.image-popup').click(function(e) {
  if (!$(e.target).hasClass('image-popup__close')) {
    $('.image-popup').css('display', 'none');
    Cookies.set('seen_popup_june', true, { expires: 7 });

    var url = $(this).data('link');
    window.location.href = url;
  }
  
});

$('.image-popup__close').click(function() {
  $('.image-popup').css('display', 'none');
  Cookies.set('seen_popup_june', true, { expires: 7 });
});